export default __webpack_public_path__ + "static/media/logoss.c9193e43.png";